import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';

import { Layout, Result, Spin } from '@components/atoms';
import BodyContainer from '@containers/App/Body';

type TErrorObj = {
  message?: string;
};

type TErrorFallbackParams = {
  error: TErrorObj;
};

function ErrorFallback({ error = {} }: TErrorFallbackParams) {
  return (
    <Result title="Unhandled Error">
      <span>{error.message}</span>
    </Result>
  );
}

const loadable = (Component: any) => (props: any) => {
  const { globalReducer }: any = useSelector((state) => state);
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Spin spinning={globalReducer.requestLoading}>
        <Layout yzTypeLayout="APP">
          <Component {...props} />
        </Layout>
      </Spin>
    </ErrorBoundary>
  );
};

export const Body = loadable(BodyContainer);
